import { render, staticRenderFns } from "./PainelBolsasAuxilios.vue?vue&type=template&id=1a5a5abc"
import script from "./PainelBolsasAuxilios.vue?vue&type=script&lang=js"
export * from "./PainelBolsasAuxilios.vue?vue&type=script&lang=js"
import style0 from "./PainelBolsasAuxilios.vue?vue&type=style&index=0&id=1a5a5abc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports